// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    Col,
    Row,
} from "reactstrap"
import { listSurvey } from "store/actions";


//import components
import { withTranslation } from "react-i18next";

const PhaseThree = props => {
    //meta title
    document.title = `${props.t("Survey Phase Three")}  | ${props.t("Participant")}`;
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { surveyData, loading, error, successMsg } = useSelector((state) => state.Survey);

    useEffect(() => {
        // if (surveyData?.survey_status == "complete") {
        //     navigate('/dashboard')
        // }
    }, [surveyData])
    
    
    useEffect(() => {
        fetchSurveyData()
    }, [])

    const fetchSurveyData = () => {
        dispatch(listSurvey("participant"))
    }

    const onNext = () => {
        // if (state?.surveyData?.survey?.phase_four.length === 0) {
        //     navigate('/complete-self-servey/phase-five', { state: { surveyData: state?.surveyData, prev_two_page_index: state?.prev_two_page_index } });
        // } else {
        //     navigate('/complete-self-servey/phase-four', { state: { surveyData: state?.surveyData, prev_two_page_index: state?.prev_two_page_index } });

        // }

        if (surveyData?.survey?.phase_four.length === 0) {

            navigate('/complete-self-servey/phase-five', {
                state: {
                    surveyData: surveyData,
                    prev_two_page_index: state?.prev_two_page_index
                }
            });
        } else {

            navigate('/complete-self-servey/phase-four', {
                state: {
                    surveyData: surveyData,
                    prev_two_page_index: state?.prev_two_page_index,

                }
            });

        }
    }

    return (
        <React.Fragment>

            {loading ?
                <div className="loader d-flex justify-content-center align-items-center mt-5" >
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                    {props.t("Loading")}
                </div>
                :
                <div className="page-content">
                    <div className="container-fluid">
                        {/* <Breadcrumbs title={props.t("Configuration")} breadcrumbItem={props.t("Manage Languages")} /> */}

                        <Row>
                            <div className="self-survey-main">
                                {/* <div className="self-survey-inner self-survey-inner-border" dangerouslySetInnerHTML={{ __html: state?.surveyData?.survey?.phase_three }} /> */}
                                <div className="self-survey-inner self-survey-inner-border" dangerouslySetInnerHTML={{ __html: surveyData?.survey?.phase_three }} />
                                <div className="self-survey-inner-btn-div">
                                    <button className="previous-ques" onClick={() => navigate('/complete-self-servey/phase-two', {
                                        state: {
                                            surveyData: state?.surveyData,
                                            prev_two_page_index: state?.prev_two_page_index,

                                        }
                                    })}>{props.t('Previous')}</button>
                                    <button className="self-survey-btn" onClick={() => onNext()}>{props.t('Next')}</button>
                                </div>
                            </div>
                        </Row>
                    </div>
                </div>
            }
        </React.Fragment>
    );
}

PhaseThree.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(PhaseThree);
